import React from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from '@mui/material'

const ExportZohoDialog = ({ open, onClose, onConfirm, plantName, invoiceNumber, count = 1 }) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle sx={{ fontWeight: 'bold' }}>Export to Zoho Books</DialogTitle>
            <DialogContent>
                <Typography variant="body1">
                    {count > 1
                        ? `Are you sure you want to export ${count} selected invoices to Zoho Books?`
                        : `Are you sure you want to export invoice ${invoiceNumber} for ${plantName} to Zoho Books?`
                    }
                </Typography>
                <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary', fontWeight: 'bold' }}>
                    This action cannot be undone.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="inherit">
                    Cancel
                </Button>
                <Button onClick={onConfirm} color="primary" variant="contained">
                    Confirm Export
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ExportZohoDialog
